import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, TemplateRef } from "@angular/core";
import { NzAlertComponent } from "ng-zorro-antd/alert";
import { WithConfig } from "ng-zorro-antd/core/config";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { UiAlertButtonType, UiAlertIconType, UiAlertType } from "@webapp/ui/alert/alert.models";

@Component({
  selector: "ui-alert",
  exportAs: "uiAlert",
  templateUrl: "alert.component.html",
  styleUrls: ["alert.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "ui-alert",
  },
})
export class UiAlertComponent extends NzAlertComponent implements OnInit {
  @Input("uiCloseText") public nzCloseText: string | TemplateRef<void> | null = null;
  @Input("uiIconType") public nzIconType: string | null = null;
  @Input("uiMessage") public nzMessage: string | TemplateRef<void> | null = null;
  @Input("uiDescription") public nzDescription: string | TemplateRef<void> | null = null;
  @Input("uiType") public nzType: UiAlertType = "info";
  @Input("uiCloseable") @WithConfig() @InputBoolean() public nzCloseable = false;
  @Input("uiShowIcon") @WithConfig() @InputBoolean() public nzShowIcon = true;
  @Input("uiBanner") @InputBoolean() public nzBanner = false;
  @Input() public uiButtonType: UiAlertButtonType = "info";
  @Input() public uiPrimaryCTA: string | null = null;
  @Input() public uiSecondaryCTA: string | null = null;
  @Input() public uiTertiaryCTA: string | null = null;
  @Output("uiOnClose") public readonly nzOnClose = new EventEmitter<boolean>();
  @Output() public readonly uiOnPrimaryAction = new EventEmitter<void>();
  @Output() public readonly uiOnSecondaryAction = new EventEmitter<void>();
  @Output() public readonly uiOnTertiaryAction = new EventEmitter<void>();

  public shouldDisplayPrimaryAction = false;
  public shouldDisplaySecondaryAction = false;
  public shouldTertiaryAction = false;
  public uiInferredIconType: UiAlertIconType;

  public ngOnInit(): void {
    this.setUiInferredIconType();

    this.shouldDisplayPrimaryAction = this.uiPrimaryCTA && !!this.uiOnPrimaryAction;
    this.shouldDisplaySecondaryAction = this.uiSecondaryCTA && !!this.uiOnSecondaryAction;
    this.shouldTertiaryAction = this.uiTertiaryCTA && !!this.uiOnTertiaryAction;
  }

  public closeAlert(): void {
    super.closeAlert();

    this.nzOnClose.emit(true);
  }

  private setUiInferredIconType(): void {
    switch (this.nzType) {
      case "success": {
        this.uiInferredIconType = "verification";
        break;
      }
      case "warning": {
        this.uiInferredIconType = "attention";
        break;
      }
      case "error": {
        this.uiInferredIconType = "failed";
        break;
      }
      case "info":
      default:
        this.uiInferredIconType = "info";
    }
  }

  public onPrimaryAction(): void {
    this.uiOnPrimaryAction.emit();
  }

  public onSecondaryAction(): void {
    this.uiOnSecondaryAction.emit();
  }

  public onTertiaryAction(): void {
    this.uiOnTertiaryAction.emit();
  }
}
